
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 69.545 66.968","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('filter',{attrs:{"id":"a","filterUnits":"userSpaceOnUse","height":"66.968","width":"69.545","x":"0","y":"0"}},[_c('feOffset',{attrs:{"dx":"2","dy":"3"}}),_c('feGaussianBlur',{attrs:{"result":"b","stdDeviation":"3"}}),_c('feFlood',{attrs:{"flood-opacity":".161"}}),_c('feComposite',{attrs:{"in2":"b","operator":"in"}}),_c('feComposite',{attrs:{"in":"SourceGraphic"}})]),_c('g',{attrs:{"filter":"url(#a)"}},[_c('path',{attrs:{"d":"M54.524 6.002H11.017a4 4 0 00-4.019 3.983v29.754a4 4 0 004.019 3.983h2.8v9.533a1.717 1.717 0 001.069 1.586 1.741 1.741 0 001.888-.373l10.845-10.745h26.91a4 4 0 004.019-3.983V9.985a4 4 0 00-4.024-3.983z","fill":"#3c8e00"}})]),_c('g',{attrs:{"fill":"#fff"}},[_c('path',{attrs:{"d":"M33.088 34.196a24.849 24.849 0 0016.241-5.677l-1.276-1.488a24.109 24.109 0 01-29.956-.022l-1.279 1.484a24.829 24.829 0 0016.27 5.703z"}}),_c('circle',{attrs:{"cx":"41.398","cy":"16.645","r":"2.587"}}),_c('circle',{attrs:{"cx":"24.752","cy":"16.645","r":"2.587"}})])])
          )
        }
      }
    